import { MpLayoutOptionContent } from './MpLayoutOptionContent';
export default MpLayoutOptionContent;